import {
  EMPTY_BOOKING_PEOPLE_CONTEXT,
  type BookingPeopleContext,
  type BookingResource,
  type BookingSlotResource,
} from "./bookingPeople";
import { getSupabaseClient } from "./supabase";

export async function loadBookingPeopleContext(): Promise<BookingPeopleContext> {
  const supabase = getSupabaseClient();
  const { data, error } = await supabase.rpc("public_booking_people_context");
  if (error) throw error;
  return normalizeBookingPeopleContext(data);
}

export function normalizeBookingPeopleContext(value: unknown): BookingPeopleContext {
  if (!value || typeof value !== "object") return EMPTY_BOOKING_PEOPLE_CONTEXT;

  const candidate = value as { resources?: unknown; slots?: unknown };
  const resources = Array.isArray(candidate.resources)
    ? candidate.resources.map(normalizeResource).filter((item): item is BookingResource => Boolean(item))
    : [];
  const slots = Array.isArray(candidate.slots)
    ? candidate.slots.map(normalizeSlot).filter((item): item is BookingSlotResource => Boolean(item))
    : [];

  return { resources, slots };
}

function normalizeResource(value: unknown): BookingResource | undefined {
  if (!value || typeof value !== "object") return undefined;
  const resource = value as Partial<BookingResource>;
  if (
    typeof resource.id !== "string" ||
    typeof resource.slug !== "string" ||
    typeof resource.name !== "string" ||
    typeof resource.timezone !== "string" ||
    !Array.isArray(resource.offerIds)
  ) {
    return undefined;
  }

  return {
    id: resource.id,
    slug: resource.slug,
    name: resource.name,
    timezone: resource.timezone,
    offerIds: resource.offerIds.filter((offerId): offerId is string => typeof offerId === "string"),
  };
}

function normalizeSlot(value: unknown): BookingSlotResource | undefined {
  if (!value || typeof value !== "object") return undefined;
  const slot = value as Partial<BookingSlotResource>;
  if (typeof slot.id !== "string" || typeof slot.resourceId !== "string") return undefined;
  return { id: slot.id, resourceId: slot.resourceId };
}
